module.exports = __webpack_public_path__ + "static/media/wellbeing.14eb1541.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/wellbeing.png
// module id = ./src/images/agendaIcons/wellbeing.png
// module chunks = 1